<template>
  <div class="page">
    <MyTitle type="1" title="边缘智算AI" class="title-scale"/>
    <div class="pageBox"></div>
    <div :class="`text-${index + 1}`" v-for="(item, index) in list" :key="index">
      <span  :class="['label', index == Iindex  && item.uuid != 'TFlops' ? 'animated-font' : '']">{{ item.label }}</span
      >
      <!-- <animate-number
      v-else
          ref="reNum"
          class="label"
          from="0"
          :to="item.label"
          :key="item.label"
          duration="500"
        ></animate-number> -->
      <span class="uuid">{{ item.uuid }}</span>
    </div>
  </div>
</template>

<script>
import MyTitle from '@/views/exposition/components/title2'
export default {
  components: {
    MyTitle,
  },
  data() {
    return {
      list: [
        {
          label: "AI识别",
          uuid: "",
        },
        {
          label: "仓储自动化",
          uuid: "",
        },
        {
          label: "AGV无损漫游",
          uuid: "",
        },
        {
          label: "仿真与模拟",
          uuid: "",
        },
        {
          label: "视觉AI质检",
          uuid: "",
        },
        {
          label: "巡检算法优化",
          uuid: "",
        },
        {
          label: "数字孪生",
          uuid: "",
        },
        {
          label: 2671,
          uuid: "TFlops",
        },
      ],
      Iindex: 0,
      timer: null,
      timer1: null
    };
  },
  mounted() {
    this.timer = setInterval(() =>{
      if(this.Iindex >= 8){
        this.Iindex = -1
      }
      this.Iindex++
      console.log(this.Iindex,'idnex')
    },3000)
    this.timer1 = setInterval(() =>{
      this.list[7].label = this.generateRandomNumber(3000,4000)
    },3000)
  },
  methods: {
    generateRandomNumber(min, max) {
      var randomNumber = Math.random() * (max - min) + min;
      return Math.floor(randomNumber);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timer1);
  },
};
</script>

<style lang="scss" scoped>
// @import './page.scss';
@import "@/assets/scss/comm.scss";
$i : 1;
.page {
  width: 967px;
  height: 778px;
  // background: red;
  position: relative;
}
.pageBox {
  position: absolute;
  left: 205px;
  top: -200px;
  width: 537px;
  height: 1600px;
  background: url("~@/assets/images/digitalfactory/GPU.png") no-repeat;
  background-size: 100% auto;
  background-position: 0 100px;
}

.pageBox {
  position: absolute;
  left: 205px;
  top: -200px;
  width: 537px;
  height: 1600px;
  background: url("~@/assets/images/digitalfactory/GPU2.png") no-repeat;
  background-size: 100% auto;
  background-position: 0 100px;
  opacity: .6;
}

@for $i from 1 through 9 {
    .text-#{$i}{
        position: absolute;
        font-size:  42px;
        z-index: 1;
        color: #cccccc;
    }
}

.text-1{
    top: 260px;
    left: 150px;
}

.text-2{
    top: 270px;
    right: 200px;
}

.text-3{
    top: 500px;
    left: 0px;
}

.text-4{
    top: 380px;
    right: 80px;
}

.text-5{
    top: 400px;
    left: 250px;
}

.text-6{
    top: 650px;
    left: 300px;
}

.text-7{
    top: 550px;
    right: 150px;
}

.text-8{
    top: 69px;
    right: 275px;
    color: $FontColor2;
    .label{
      font-size: 125px;
      @include ffamily-DS;
      
    }
}

.text-9{
    top: 700px;
    right: 350px;
    color: #F6F6F6;
}

@keyframes fontAnimation {
    0% {
      font-size: 50px;
    }

    100% {
      font-size: 70px;
      color: #F6F6F6;;
    }
  }

  .animated-font {
    animation: fontAnimation 3s infinite;
  }

</style>